import { combineEpics, Epic } from 'redux-observable';
import { authEpic } from './auth';
import { tableFetchDataEpic } from './table';
import { newsFetchDataEpic } from '../next/modules/news/epics/news';

const epics: Epic[] = [authEpic, tableFetchDataEpic, newsFetchDataEpic];

export default combineEpics(...epics);
